<template>
	<div class="chat_wrapper">
		<!-- 모달 : 비밀번호 변경 start -->
		<div
			id="modal_pw_edit"
			class="chat_modal flexible"
			style="display: block; position: fixed;"
		>
			<div class="chat_modal_in">
				<div class="chat_modal_head">
					<div class="primary_c">
						<strong>비밀번호 변경</strong>
					</div>
					<button class="btn_modal_close fas fa-times" @click="close">
						<span class="bg_clip">닫기</span>
					</button>
				</div>

				<!-- 내용 start -->
				<div class="chat_modal_cont overflow_auto">
					<ul class="form_set">
						<li>
							<label for="pw_edit01" class="type_text"
								>현재 비밀번호 <span class="text_small red">*</span></label
							><input
								id="pw_edit01"
								ref="pw"
								v-model="pw"
								type="password"
								class="chat_form_gray"
							/>
						</li>
						<li>
							<label for="pw_edit02" class="type_text"
								>새로운 비밀번호 <span class="text_small red">*</span></label
							><input
								id="pw_edit02"
								ref="newPw"
								v-model="newPw"
								type="password"
								class="chat_form_gray"
							/>
						</li>
						<li>
							<label for="pw_edit03" class="type_text"
								>비밀번호 확인 <span class="text_small red">*</span>
							</label>
							<input
								id="pw_edit03"
								ref="newPwCheck"
								v-model="newPwCheck"
								type="password"
								class="chat_form_gray"
								@input="pwCheckFail = newPw !== newPwCheck"
							/>
							<div v-if="pwCheckFail" class="text_small red mt-5px">
								<i class="fas fa-exclamation-circle" /> 비밀번호를 확인하시기
								바랍니다.
							</div>
							<div class="text_small mt-5px">
								(비밀번호는 6~12자 이내 문자/숫자를 섞어서 사용)
							</div>
						</li>
					</ul>
				</div>
				<!--// 내용 end -->

				<div class="chat_modal_foot">
					<ul class="bot_btnset horizontal align_center half">
						<li>
							<button
								class="btn medium primary_c_bd btn_modal_close"
								@click="close"
							>
								취소
							</button>
						</li>
						<!-- 닫기 .btn_modal_close 추가 -->
						<li>
							<button class="btn medium primary_c" @click="saveData">
								확인
							</button>
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!--// 모달 : 비밀번호 변경 end -->
	</div>
</template>

<script>
import UtilsCrypto from '../../api/crypto';
import config from '../../config/config.json';

export default {
	props: {
		id: {
			type: String,
			default: null,
			required: false,
		},
	},
	data() {
		return {
			pw: '',
			newPw: '',
			newPwCheck: '',
			pwCheckFail: false,
		};
	},
	mounted() {
		window.addEventListener('resize', this.modalStyleSetting);
		this.modalStyleSetting();
	},
	methods: {
		saveData() {
			if (!this.pw) {
				alert('비밀번호 항목은 필수 항목입니다.');
				this.$refs.pw.focus();
				return;
			}
			const pwRegex = /^(?=.*[a-zA-Z])((?=.*\d)|(?=.*\W)).{6,12}$/;
			if (!pwRegex.exec(this.newPw)) {
				alert('비밀번호는 숫자와 문자를 포함하여 6~12자리로 작성해야 합니다.');
				this.newPw = '';
				this.newPwCheck = '';
				this.$refs.newPw.focus();
				return;
			}
			if (this.pwCheckFail) {
				alert('비밀번호가 일치하지 않습니다.');
				this.newPw = '';
				this.newPwCheck = '';
				this.$refs.newPw.focus();
				return;
			}

			this.$axios
				.put(
					config.MBR_REST_API_PATH + '/mem/pw',
					{
						mbrId: this.id,
						pw: UtilsCrypto.cryptoAesEncrypt(this.pw),
						newPw: UtilsCrypto.cryptoAesEncrypt(this.newPw),
					},
					{ headers: { 'Content-Type': 'application/json' } },
				)
				.then(response => {
					const result = response.data;
					if (result === 'incorrect') {
						alert('현재 비밀번호가 틀렸습니다.');
					} else if (result === 'success') {
						alert('비밀번호 변경이 완료되었습니다.');
						this.close();
					} else if (result === 'fail') {
						alert('비밀번호 변경을 실패하였습니다.');
					}
					this.pw = '';
					this.newPw = '';
					this.newPwCheck = '';
					this.$refs.pw.focus();
				});
		},
		close() {
			this.$emit('close');
		},
		modalStyleSetting() {
			const modal = document.getElementById('modal_pw_edit');

			if (modal.classList.contains('flexible')) {
				const browser_height = window.innerHeight - 200;
				modal
					.getElementsByClassName('chat_modal_cont')[0]
					.setAttribute('style', 'max-height: ' + browser_height + 'px');

				const chat_modal_in = modal.getElementsByClassName('chat_modal_in')[0];
				const modal_height =
					(window.innerHeight - chat_modal_in.clientHeight) / 2;
				const modal_width = (window.innerWidth - chat_modal_in.clientWidth) / 2;
				chat_modal_in.setAttribute(
					'style',
					'margin-top: ' +
						modal_height +
						'px; margin-left: ' +
						modal_width +
						'px;',
				);
			} else if (modal.classList.contains('slide')) {
				const browser_height = window.innerHeight - 150;
				modal
					.getElementsByClassName('chat_modal_cont')[0]
					.setAttribute('style', 'max-height: ' + browser_height + 'px');

				const chat_modal_in = modal.getElementsByClassName('chat_modal_in')[0];
				chat_modal_in.setAttribute('style', 'bottom: 0');
			}
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/components/member/PwEdit.vue